import { Product } from '../types/product';
import { Brand } from '../types/brand';
import { ShippingMethod, Market } from '../types/product';

/**
 * Get product name in the specified language with fallback to English
 */
export const getProductName = (product: Product, language: string): string => {
  switch (language) {
    case 'zh':
      return product.nameZh || product.name;
    case 'cn':
      return product.nameCn || product.name;
    default:
      return product.name;
  }
};

/**
 * Get product description in the specified language with fallback to English
 */
export const getProductDescription = (product: Product, language: string): string => {
  switch (language) {
    case 'zh':
      return product.descriptionZh || product.description;
    case 'cn':
      return product.descriptionCn || product.description;
    default:
      return product.description;
  }
};

/**
 * Get brand name in the specified language with fallback to English
 */
export const getBrandName = (product: Product, language: string): string => {
  if (!product.brandInfo) return '';
  
  switch (language) {
    case 'zh':
      return product.brandInfo.nameZh || product.brandInfo.name;
    case 'cn':
      return product.brandInfo.nameCn || product.brandInfo.name;
    default:
      return product.brandInfo.name;
  }
};

/**
 * Get brand name in the specified language with fallback to English
 */
export const getBrandNameFromBrand = (brand: Brand, language: string): string => {
  switch (language) {
    case 'zh':
      return brand.nameZh || brand.name;
    case 'cn':
      return brand.nameCn || brand.name;
    default:
      return brand.name;
  }
};

/**
 * Get brand description in the specified language with fallback to English
 */
export const getBrandDescriptionFromBrand = (brand: Brand, language: string): string => {
  switch (language) {
    case 'zh':
      return brand.descriptionZh || brand.description;
    case 'cn':
      return brand.descriptionCn || brand.description;
    default:
      return brand.description;
  }
};

/**
 * Get shipping method name in the specified language with fallback to English
 */
export const getShippingMethodName = (shippingMethod: ShippingMethod, language: string): string => {
  switch (language) {
    case 'zh':
      return shippingMethod.nameZh || shippingMethod.name;
    case 'cn':
      return shippingMethod.nameCn || shippingMethod.name;
    default:
      return shippingMethod.name;
  }
};

/**
 * Get shipping method description in the specified language with fallback to English
 */
export const getShippingMethodDescription = (shippingMethod: ShippingMethod, language: string): string => {
  switch (language) {
    case 'zh':
      return shippingMethod.descriptionZh || shippingMethod.description || '';
    case 'cn':
      return shippingMethod.descriptionCn || shippingMethod.description || '';
    default:
      return shippingMethod.description || '';
  }
};

/**
 * Get market name in the specified language with fallback to English
 */
export const getMarketName = (market: Market, language: string): string => {
  switch (language) {
    case 'zh':
      return market.nameZh || market.name;
    case 'cn':
      return market.nameCn || market.name;
    default:
      return market.name;
  }
};
